import { generatePath } from '@/services/router/generate-path';

export const getWorkspaceSettingsLink = () => {
  return (workspaceId: number | 'last') => generatePath('/workspaces/:workspaceId/settings', { workspaceId });
};
